import { LabourHour, LabourHourLineItem } from "@interfaces/labourHour";
import { decodeEmploymentType, decodeGender } from "./employee";

export const decodeLabourHour = (
  labourHour: LabourHour
): LabourHourLineItem => {
  return {
    id: labourHour.labour_hour_id,
    reportId: labourHour.contractor_report_id,
    employeeId: labourHour.contractor_employee_id,
    employeeName: labourHour.employee_name,
    gender: decodeGender(labourHour.gender),
    employmentType: decodeEmploymentType(labourHour.employment_type),
    socialFactors: labourHour.social_factors,
    amount: labourHour.amount,
    created: new Date(labourHour.created),
  };
};

export const encodeLabourHour = (
  labourHour: LabourHourLineItem
): LabourHour => {
  return {
    labour_hour_id: labourHour.id,
    contractor_report_id: labourHour.reportId,
    contractor_employee_id: labourHour.employeeId,
    amount: labourHour.amount,
    employee_name: labourHour.employeeName,
    gender: labourHour.gender,
    employment_type: labourHour.employmentType,
    social_factors: labourHour.socialFactors,
    created: labourHour.created,
  };
};
